"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ECategorieSocialProfessionnel_1 = require("../../enums/ClientSheet/ECategorieSocialProfessionnel");
const ECivility_1 = require("../../enums/ClientSheet/ECivility");
const ELegalCapacity_1 = require("../../enums/ClientSheet/ELegalCapacity");
const ECountry_1 = require("../../enums/Country/ECountry");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const AddressCreateRequestResource_1 = __importDefault(require("../Address/AddressCreateRequestResource"));
const Custom_1 = __importDefault(require("../decorators/Custom"));
const Resource_1 = __importDefault(require("../Resource"));
const ECorporationResourceGroups_1 = require("../../enums/CorporationSheet/Groups/ECorporationResourceGroups");
class ClientSheetCreateLegalRepresentativeRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.civility = ECivility_1.ECivility.non_communique;
        this.politicallyExposed = false;
        this.personUS = false;
    }
}
exports.default = ClientSheetCreateLegalRepresentativeRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECivility_1.ECivility),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "civility", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.civility === ECivility_1.ECivility.madame)
            return true;
        obj.maidenName = null;
        return false;
    }),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "maidenName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "birthPlace", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "birthDepartment", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "birthCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "nationality", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "profession", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "nif", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumberString)({ no_symbols: false }),
    (0, class_validator_1.IsPhoneNumber)("FR"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "taxResidenceCountry", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ELegalCapacity_1.ELegalCapacity),
    (0, Custom_1.default)((value) => value === ELegalCapacity_1.ELegalCapacity.majeur_capable, { message: ValidationErrors_1.EValidationError.blockOperation, groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.representantLegal, ECorporationResourceGroups_1.ECorporationResourceGroups.beneficiaries] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "legalCapacity", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "politicallyExposed", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, Custom_1.default)((value) => value === false, { message: ValidationErrors_1.EValidationError.personUSmustBeFalse }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "personUS", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "agreementElectronicDocument", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AddressCreateRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", AddressCreateRequestResource_1.default)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.MinLength)(1, { context: [1] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "lineOfBusiness", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ECategorieSocialProfessionnel_1.ECategorieSocialProfessionnel),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ClientSheetCreateLegalRepresentativeRequestResource.prototype, "categorieSocialProfessionnel", void 0);
